import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";

import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import { RequestTypeResponse } from "./requestTypeSlice";

export const requestTypesData = createAsyncThunk<RequestTypeResponse[], void>(
  "/requestTypesData",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await api.get(`/request-types`, config);

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);
